<template>
  <div class="row align-items-top">
    <div class="col-md-1 border-sm-top  striped-sm">
      OS: &nbsp;&nbsp;&nbsp;<div class="d-none d-md-block"></div><strong>
        {{ execucao.nr_sequencial }}
      </strong>
    </div>
    <div class="col-md-2 border-sm-top  striped-sm">
      {{ $t('Placa') }}: &nbsp;&nbsp;&nbsp;<div class="d-none d-md-block"></div><strong>
        {{ execucao.nr_placa }}
      </strong>
    </div>
    <div class="col-md-2 border-sm-top  striped-sm">
      {{ $t('Início Atendimento') }}: &nbsp;&nbsp;&nbsp;<div class="d-none d-md-block"></div><strong>
        {{ execucao.liberacao ? formatDate(execucao.liberacao.dt_inicio) : "00/00/0000 00:00" }}
      </strong>
    </div>
    <div class="col-md-2  striped-sm">
      {{ $t('Problema') }}: &nbsp;&nbsp;&nbsp;<div class="d-none d-md-block"></div>
      <strong v-if="execucao.ds_conjunto">{{ execucao.ds_conjunto }} </strong>
    </div>
    <div class="col-md-2  striped-sm">
      {{ $t('Serviço') }}: &nbsp;&nbsp;&nbsp;<div class="d-none d-md-block"></div>
      <strong v-if="execucao.ds_grupo">{{ execucao.ds_grupo }} </strong>
    </div>
    <div class="col-md-3 striped-sm">
      {{ $t('Colaborador') }}: &nbsp;&nbsp;&nbsp;<div class="d-none d-md-block"></div>
      <strong>{{ execucao.liberacao.colaborador ? execucao.liberacao.colaborador.ds_colaborador : '' }} </strong>
    </div>
    <!-- <div class="col-md-2 text-right  striped-sm" >
      <div class="d-block d-md-none mt-3"></div>
      <router-link class="btn btn-success m-2" :to="'os/' + execucao.nr_sequencial">
        <i class="fas fa-sign-out-alt"></i> {{ $t('Acessar OS') }}
      </router-link>
    </div> -->
  </div>
</template>

<script>

export default {
  props: {
    execucao: {},
    exibeParar: {}
  },
  data() {
    return { items: '', idConjunto: '', inputOptions: '', show: false, selectServico: '', ds_tipo: '', showModalItems: false, cod_item: ''}
  },
  computed: {
    dataAtendimento() {
      if(this.execucao.dt_inicial){ 
        var data = this.execucao.dt_inicial
        var dia = data.substring(8, 10)
        var mes = data.substring(5, 7)
        var ano = data.substring(0, 4)
        var hora = data.substring(11, 13)
        var minutos = data.substring(14, 16)

        return dia + '/' + mes + '/' + ano + ' ' + hora + ':' + minutos
      } else {
        return '00' + '/' + '00' + '/' + '0000' + ' ' + '00' + ':' + '00'
      }

    },
    bgBackground() {
      return true
    },
    // getHoursSlaAtual (){
    //   const data = new Date(this.execucao.dt_inicio)
    //   const horaAt = data.getHours()
    //   const minAt = data.getMinutes()

    //   const sla = this.execucao.item.os.conjunto.hr_sla

    //   const horaSla = sla.substring(0,2)
    //   const minSla = sla.substring(3,5)

    //   return `${parseInt(horaAt) + parseInt(horaSla)}:${parseInt(minAt) + parseInt(minSla)}:00`
    // } 
  },
  created () {
    console.log(this.execucao)
  },
  methods: {
    formatDate(date) {
      if (!date) return "00/00/0000 00:00"; // Verifica se a data está definida

      const d = new Date(date);

      // Obter dia, mês e ano
      const day = String(d.getDate()).padStart(2, '0');
      const month = String(d.getMonth() + 1).padStart(2, '0'); // Mês começa do 0
      const year = d.getFullYear();

      // Obter horas e minutos
      const hours = String(d.getHours()).padStart(2, '0');
      const minutes = String(d.getMinutes()).padStart(2, '0');

      // Retornar data formatada: "DD/MM/YYYY HH:mm"
      return `${day}/${month}/${year} ${hours}:${minutes}`;
    }
  }
}
</script>